import { Box } from "@mui/material";
import RedirectActions from "./RedirectActions";
import RedirectsTable from "./RedirectsTable";
import RedirectImportTable from "./RedirectImportTable";
const RedirectsManager = () => {
  return <>
      <Box display="flex" justifyContent="space-between" px={4} pt={4} pb={1.75} sx={{
      borderBottom: theme => `2px solid ${theme.palette.border}`,
      backgroundColor: "background.paper"
    }} data-sentry-element="Box" data-sentry-source-file="index.tsx">
        <RedirectActions data-sentry-element="RedirectActions" data-sentry-source-file="index.tsx" />
      </Box>
      <Box flexGrow={1} display="flex" flexDirection="column" justifyContent="center" alignItems="flex-start" px={4} boxSizing="border-box" position="relative" sx={{
      height: `calc(100% - 68px - 40px)`
    }} data-sentry-element="Box" data-sentry-source-file="index.tsx">
        <RedirectsTable data-sentry-element="RedirectsTable" data-sentry-source-file="index.tsx" />
        <RedirectImportTable data-sentry-element="RedirectImportTable" data-sentry-source-file="index.tsx" />
      </Box>
    </>;
};
export default RedirectsManager;